import styled, { css } from 'styled-components';
import { colorAliases, colors } from '../../../../variables/colors.js';
import { deviceWidths } from '../../../../variables/widths.js';
import { transitions } from '../../../../variables/transitions.js';
import { fonts } from '../../../../variables/fonts.js';

var HotelHitContentHeaderContainer = styled.div.withConfig({
  displayName: "hotelHitContentHeader__HotelHitContentHeaderContainer",
  componentId: "sc-8ydahy-0"
})(["padding:8px;position:relative;display:flex;@media (min-width:", "){padding:16px;}"], deviceWidths.tablet);
var HotelHitContentHeaderLeft = styled.div.withConfig({
  displayName: "hotelHitContentHeader__HotelHitContentHeaderLeft",
  componentId: "sc-8ydahy-1"
})(["flex-basis:100%;", ""], function (props) {
  return props.esg && css(["flex-basis:calc(100% - 50px);@media (min-width:", "){flex-basis:calc(100% - 64px);}"], deviceWidths.tablet);
});
var HotelHitContentHeaderRight = styled.div.withConfig({
  displayName: "hotelHitContentHeader__HotelHitContentHeaderRight",
  componentId: "sc-8ydahy-2"
})(["flex-basis:50px;display:flex;justify-content:flex-end;@media (min-width:", "){flex-basis:64px;}"], deviceWidths.tablet);
var HotelHitContentTitle = styled.h3.withConfig({
  displayName: "hotelHitContentHeader__HotelHitContentTitle",
  componentId: "sc-8ydahy-3"
})(["line-height:18px;margin-right:48px;font-family:", ";", " @media (min-width:", "){font-size:27px;line-height:30px;}a{color:", ";cursor:default;padding-right:4px;transition:color ", ";@media (min-width:", "){position:relative;z-index:1;}.no-touch &:hover{color:", ";cursor:pointer;}}span{color:", ";}"], fonts.bold, function (props) {
  return props.esg && css(["margin-right:18px;"]);
}, deviceWidths.tablet, colorAliases.text, transitions["default"], deviceWidths.tablet, colors.black, colors.black);
var HotelHitContentSubTitleContainer = styled.div.withConfig({
  displayName: "hotelHitContentHeader__HotelHitContentSubTitleContainer",
  componentId: "sc-8ydahy-4"
})(["color:", ";font-size:14px;margin:4px 36px 0 0;@media (min-width:", "){font-size:18px;}"], colors.mediumGray, deviceWidths.tablet);
var HotelHitContentSubTitle = styled.span.withConfig({
  displayName: "hotelHitContentHeader__HotelHitContentSubTitle",
  componentId: "sc-8ydahy-5"
})(["color:", ";font-family:", ";font-size:15px;transition:color ", ";white-space:pre-wrap;cursor:default;&::after{content:', ';}&:last-child::after{content:'';}@media (min-width:", "){font-size:18px;position:relative;z-index:1;}", ""], colors.mediumGray, fonts.light, transitions["default"], deviceWidths.tablet, function (props) {
  return props.as !== 'span' && css(["&:hover{color:", ";cursor:pointer;}"], colorAliases.text);
});
var RatingContainer = styled.div.withConfig({
  displayName: "hotelHitContentHeader__RatingContainer",
  componentId: "sc-8ydahy-6"
})(["display:flex;margin-top:4px;@media (min-width:", "){margin-top:8px;}"], deviceWidths.tablet);

export { HotelHitContentHeaderContainer, HotelHitContentHeaderLeft, HotelHitContentHeaderRight, HotelHitContentSubTitle, HotelHitContentSubTitleContainer, HotelHitContentTitle, RatingContainer };
//# sourceMappingURL=hotelHitContentHeader.js.map
